export const itemsBaseApiPath = '/api/common/userInvites';
import { apiHelperGenerators } from '@/shared';
const {
  fetchItemsGen,
  deleteItemGen,
  getItemByIdGen,
  editItemGen,
  addItemGen
} = apiHelperGenerators;

// pending invites first, then the users of the brands the current user has access to
export const fetchItems = fetchItemsGen(itemsBaseApiPath, 'listWithUsers');
export const deleteItem = deleteItemGen(itemsBaseApiPath);
export const getItemById = getItemByIdGen(itemsBaseApiPath);
export const addItem = addItemGen(itemsBaseApiPath);
export const editItem = editItemGen(itemsBaseApiPath, 'put');

export const resendItem = id => {
  return new Promise((resolve, reject) => {
    $http
      .post(itemsBaseApiPath + '/' + id + '/resend')
      .then(resp => {
        resolve(resp);
      })
      .catch(error => {
        console.error('resendItem error', error);
        reject(error);
      });
  });
};

export default {
  fetchItems,
  deleteItem,
  getItemById,
  addItem,
  editItem,
  resendItem
};
